export default "__VITE_ASSET__Bh9kXy6H__"